import './UsageExamples.scss';

import type { FC } from 'react';
import { Link } from 'react-router';

interface Props {
  data: {
    id: number;
    title: string;
    designers: string[];
    permalink: string;
    image: {
      url: string | null;
    };
    family?: {
      name: string;
      slug: string;
    };
  }[];
}

export const UsageExamples: FC<Props> = (props) => {
  const { data } = props;

  return (
    <div className="UsageExamples">
      {data.map((usageExample) => {
        if (usageExample.image.url == null) {
          return null;
        }

        return (
          <div key={usageExample.id} className="UsageExamples-example">
            <a
              href={usageExample.permalink}
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                className="UsageExamples-image"
                src={usageExample.image.url}
                alt={usageExample.title}
                width={220}
                height={220}
                loading="lazy"
                decoding="async"
              />
            </a>

            <div className="UsageExamples-meta">
              <a
                className="UsageExamples-title"
                href={usageExample.permalink}
                target="_blank"
                rel="noreferrer noopener"
                dangerouslySetInnerHTML={{
                  __html: usageExample.title,
                }}
              />

              {usageExample.designers.length > 0 && (
                <div>by {usageExample.designers.join(', ')}</div>
              )}

              {usageExample.family != null && (
                <Link
                  className="UsageExamples-family"
                  to={`/families/${usageExample.family.slug}`}
                >
                  {usageExample.family.name}
                </Link>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
